import storeUtils from '../utils/storeUtils';

const dao = {
  loadAuth: async () => {
    if (!storeUtils.getIsAttemptingToSignIn()) {
      return Promise.reject('loadAuth-fail');
    }
    const response = await fetch(`/smb-frontend/auth/auth.action`, {
      method: 'GET',
      credentials: 'same-origin',
    });
    if (response.ok) return await response.json();
    return Promise.reject('loadAuth-fail');
  },
};

export default dao;
